import { FC, useState } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { NavLink } from "react-router-dom";
import { ChevronRightIcon } from "@chakra-ui/icons";
import {
  borderRadius,
  menuItemStyles,
  menuItemActiveStyles,
} from "../../../utils/styles/styles";

interface MenuItemProps {
  title: string;
  link: string;
  icon: React.ReactNode;
}

const MenuItem: FC<MenuItemProps> = ({ title, link, icon }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Box w="100%">
      <NavLink
        to={link}
        style={({ isActive }) => ({
          ...(isActive || isHovered ? menuItemActiveStyles : menuItemStyles),
        })}
        end
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Flex alignItems="center" justifyContent="space-between">
          <Flex alignItems="center" gap={3}>
            <Box bgColor="#fff" borderRadius={borderRadius} p={1.5}>
              {icon}
            </Box>
            <Text fontSize="md" fontWeight="bold">
              {title}
            </Text>
          </Flex>
          <ChevronRightIcon color="white" />
        </Flex>
      </NavLink>
    </Box>
  );
};

export default MenuItem;
